import { Component, OnInit, EventEmitter } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs/Subject';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { CommentsService } from './comments.service';

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.css'],
  
})
export class CommentsComponent implements OnInit {  
  private comment: string;
  private filename: string;
  private uploadingFile: boolean;
  commentform;
  public event: EventEmitter<any> = new EventEmitter();
  public onClose: Subject<boolean>;
  private order : any;
  
  constructor(private _bsModalRef: BsModalRef,
    private spinnerService: SpinnerService,
    private commentsService : CommentsService,
    private formBuilder: FormBuilder) {

    }
 
  ngOnInit() {
    this.uploadingFile = false;
    this.filename = "";
    this.comment = "";

    this.commentform = this.formBuilder.group({
      comment: ""
      });      
    this.onClose = new Subject();
  }

  
  public onConfirm(order): void {
    this.ajaxAddComment();

}

public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
}

updateFilename(filename) {
  this.filename = filename;
}

updateUploadingFile(isUploading) {
  this.uploadingFile = isUploading;
}

ajaxAddComment() {
  //this.spinnerService.start('Merci de patienter');
  // prepare reject order data post request
  let data = new Object();
  data['orderNumber'] = this.order.number;
  data['comment'] = this.comment;
  data['filename'] = this.filename;  
  this.commentsService.postAddComment(data).then(
    function(response: any){
        this.onClose.next(true);
        this._bsModalRef.hide();
    }.bind(this),
    function(){
        this.onClose.next(true);
        this._bsModalRef.hide();
    }.bind(this)
  );
}
}




// WEBPACK FOOTER //
// ./src/app/comments/comments.component.ts